import { useState } from "react";
import { ExternalLink, X } from "lucide-react";
import { LOGO } from "@/components/PublicLayout";

const KEY = "parish-badge-min";

export const ParishSiteBadge = () => {
  const [min, setMin] = useState(() => sessionStorage.getItem(KEY) === "1");
  const toggle = (v) => { setMin(v); sessionStorage.setItem(KEY, v ? "1" : "0"); };

  return (
    <div data-testid="parish-site-badge" className="parish-badge fixed left-4 bottom-4 sm:left-6 sm:bottom-6 z-40 print:hidden">
      <div className="relative group flex items-center">
        <a
          href="https://mabuhayparish.org"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="parish-site-badge-link"
          aria-label="Visit the Saint Francis of Assisi Parish website, mabuhayparish.org"
          className="flex items-center gap-3 rounded-full bg-[#FDFBF7]/90 backdrop-blur-md border border-[#D9C9A3] shadow-[0_8px_24px_-10px_rgba(74,46,26,0.45)] p-1.5 pr-1.5 hover:pr-5 focus-visible:pr-5 transition-[padding,box-shadow,transform] duration-300 hover:-translate-y-0.5 hover:shadow-[0_12px_30px_-10px_rgba(74,46,26,0.55)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#B8892B]"
        >
          <span className="relative shrink-0">
            <span className="parish-badge-halo absolute inset-0 rounded-full" aria-hidden="true" />
            <img src={LOGO} alt="" width="44" height="43" className="relative w-11 h-11 rounded-full object-contain bg-white ring-1 ring-[#E9D49A]" />
          </span>
          <span className={`overflow-hidden whitespace-nowrap transition-[max-width,opacity] duration-300 ${min ? "max-w-0 opacity-0 group-hover:max-w-[220px] group-hover:opacity-100" : "max-w-0 opacity-0 sm:max-w-[220px] sm:opacity-100 group-hover:max-w-[220px] group-hover:opacity-100"}`}>
            <span className="block text-[10px] uppercase tracking-[0.18em] text-[#8A6A2E]">Our parish website</span>
            <span className="flex items-center gap-1 font-serif-head font-bold text-sm text-[#4A2E1A]">
              mabuhayparish.org <ExternalLink className="w-3.5 h-3.5" aria-hidden="true" />
            </span>
          </span>
        </a>
        {!min && (
          <button
            type="button"
            onClick={() => toggle(true)}
            data-testid="parish-site-badge-minimize"
            aria-label="Make parish website badge smaller"
            className="hidden sm:flex absolute -top-1.5 -right-1.5 w-5 h-5 items-center justify-center rounded-full bg-white border border-[#E7DFD5] text-[#605349] opacity-0 group-hover:opacity-100 focus-visible:opacity-100 transition-opacity hover:text-[#4A2E1A]"
          >
            <X className="w-3 h-3" />
          </button>
        )}
      </div>
    </div>
  );
};
